_ = require 'underscore'
f = require 'effing'
Auth = require 'db/auth'
OrganizationActionsComponent = require 'views/organization/organization-actions-component'
{ OrganizationMembersAd } = require 'views/organization/organization-ad-component'
OrganizationMembersFilterListComponent = require 'views/organization/organization-members-filter-list-component'
OrganizationMembersListComponent = require 'views/organization/organization-members-list-component'
OrganizationGuestListComponent = require 'views/organization/organization-guest-list-component'
React = require 'react'
t = require('views/internal/recup-with-helpers')('org_members')
Util = require 'lib/util'
xtend = require 'xtend'
ClientConfig = require 'debug/client-config'
ldclient = require 'lib/ldclient'

module.exports = class OrganizationMembersComponent extends React.Component
  constructor: (props) ->
    super
    @state =
      filter: ''
      showAll: false
      memberTypeFilter: 'team-member' # team-member, guest, enterprise
      multiboardGuestsEnabled: ldclient.variation('bc.multiboard_guests', false)

    ldclient.on 'change:bc.multiboard_guests', (newVal) =>
      @setState(multiboardGuestsEnabled: newVal)

  render: t.renderable ->
    t.div '.org-members-page-layout', =>
      t.div '.org-members-page-layout-sidebar', =>
        t.addElement @orgSidebarPropsToElement()
        if !@props.sidebar.hasBC && !@props.sidebar.isAdDismissed && !ClientConfig.get('dontUpsell')
          t.addElement @orgAdComponent()
      t.div '.org-members-page-layout-list', =>
        t.addElement @getOrganizationActionsElement()
        t.addElement @getMemberListElement()

  orgAdComponent: ->
    props =
      billingUrl: @props.sidebar.billingUrl
      dismissAd: @props.sidebar.dismissAd

    React.createElement OrganizationMembersAd, props

  isGuest: -> @props.collaboratorModels.some((guest) -> guest.isMe)

  orgSidebarPropsToElement: ->
    teamTabProps = xtend @props.sidebar,
      orgIsEmpty: @props.orgIsEmpty
      orgMemberCount: @props.orgMemberModels.length
      guestMemberCount: @props.collaboratorModels.length
      memberTypeFilter: @state.memberTypeFilter
      showGuestTab: Auth.isLoggedIn() && (@props.sidebar.model.isMember(Auth.me()) || @isGuest())
      onMemberTypeChange: (memberTypeFilter) =>
        @setState {
          memberTypeFilter
          filter: ''
        }
    return React.createElement OrganizationMembersFilterListComponent, teamTabProps

  getMemberListElement: ->
    { memberTypeFilter, multiboardGuestsEnabled } = @state
    { collaboratorModels, orgIsEmpty, orgMemberModels, orgIsBC } = @props
    memberItems = if memberTypeFilter is 'guest'
      collaboratorModels
    else if memberTypeFilter is 'team-member'
      if orgIsEmpty
        []
      else
        orgMemberModels

    listComponent = if memberTypeFilter is 'guest' && multiboardGuestsEnabled
        OrganizationGuestListComponent
      else
        OrganizationMembersListComponent

    visibleMemberItems = memberItems.filter((member) => @isVisibleMember(member))

    if memberItems.length
      return React.createElement listComponent, {
        memberTypeFilter,
        memberItems: visibleMemberItems,
        orgIsBC
      }

  isVisibleMember: (member) ->
    (!member.hidden || @state.showAll) &&
    (!@state.filter || Util.buildFuzzyMatcher(@state.filter)(member.fullName))

  getOrganizationActionsElement: ->
    props = xtend @props.sidebar,
      orgId: @props.orgId
      orgMemberCount: @props.orgMemberModels.length
      orgIsEmpty: @props.orgIsEmpty
      guestMemberCount: @props.collaboratorModels.length
      isEnterpriseAdmin: @props.isEnterpriseAdmin
      memberTypeFilter: @state.memberTypeFilter
      hasBC: @props.sidebar.hasBC
      ownsOrg: @props.sidebar.ownsOrg
      orgName: @props.orgName
      orgIsPO: @props.orgIsPO
      filter: @state.filter
      onFilterChange: (filter) =>
        @setState { filter }
      onShowAllChange: (showAll) =>
        @setState { showAll }

    React.createElement OrganizationActionsComponent, props



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-members-component.coffee